import Flex from 'components/Layout/components/Flex';
import { type BasketValidationInfo } from 'autogen/swagger/all';
import BasketErrors from './components/BasketErrors';
import BasketOTCWarnings from './components/BasketOTCWarnings';

export default function BasketValidationMessages({ model: { errors, warnings } }: { model: BasketValidationInfo }) {
    return (
        <Flex.Column>
            <BasketErrors model={errors} />
            <BasketOTCWarnings model={warnings} />
        </Flex.Column>
    );
}
